module.exports = __webpack_public_path__ + "img/MAX.e749fde2.png";